import { ErrorType } from './error.types';

export class BusinessLogicError extends Error {
    type = ErrorType.BusinessLogic;
    code?: string;

    constructor(message: string, code?: string) {
        super(message);
        this.code = code;
    }
}
